import { computed } from "vue";
import { useStore } from "vuex";
import { MODULES, vuexName } from "@/store/utils";
export const useAnnotationStore = () => {
  const { getters } = useStore();
  return {
    naturalWidthOfCurrentSlide: computed<number>(() => getters[vuexName(MODULES.ANNOTATION_V2.GETTERS.GET_IMAGE_WIDTH)]),
    naturalHeightOfCurrentSlide: computed<number>(() => getters[vuexName(MODULES.ANNOTATION_V2.GETTERS.GET_IMAGE_HEIGHT)]),
  };
};
